import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b1f9a50"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  div: "",
  class: "F-Bold F2em O-50"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_3 = {
  class: "D-Flex W-100",
  style: {"justify-content":"center"}
}
const _hoisted_4 = {
  class: "D-Flex",
  style: {"margin-inline-end":"1em"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_6 = { class: "CookiesSpacer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesLoading = _resolveComponent("CookiesLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.Translate('Whatsapp Integration')), 1),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CookiesIcon, {
          class: "SQR2_5em F3em Shadow1",
          style: {},
          ID: ('Whatsapp' as IconsIDs)
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_CookiesNormalInput, {
          class: "H-Auto",
          style: {"min-width":"50vw"},
          Res: 'WhatsAppPhoneNumberID',
          Placeholder: _ctx.Translate('Phone Number ID')
        }, null, 8, ["Placeholder"]),
        _createVNode(_component_CookiesNormalInput, {
          class: "H-Auto",
          style: {"min-width":"50vw"},
          Res: 'WhatsAppToken',
          Placeholder: _ctx.Translate('Token')
        }, null, 8, ["Placeholder"]),
        _createElementVNode("div", {
          class: _normalizeClass(["VerificationStatus F-Bold", _ctx.Verified === 'true' ? 'BGGreen': 'BGRed'])
        }, _toDisplayString(_ctx.Verified === 'true' ? _ctx.Translate('Verified') : _ctx.Translate('Not Verified')), 3),
        _hoisted_5,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.Saving ? '' : _ctx.SaveAndVerify())),
          class: _normalizeClass([_ctx.Saving ? 'Disabled': '', "CookiesButton BGMain F1_5em"])
        }, _toDisplayString(_ctx.Translate('Save and Verify')), 3),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.Saving)
            ? (_openBlock(), _createBlock(_component_CookiesLoading, { key: 0 }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}